import axios from 'axios'
import { Message, Loading } from 'element-ui'

const getBaseURL = () => {
  if (process.env.NODE_ENV === 'production') {
    const envBaseURL = process.env.VUE_APP_API_BASE_URL
    if (envBaseURL === 'USE_RELATIVE_PATH') {
      return ''
    }
    if (envBaseURL && envBaseURL !== 'USE_RELATIVE_PATH') {
      return envBaseURL
    }
    return 'http://8.130.215.242:8080'
  }
  return '/'
}

const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 如果是FormData类型文件上传，不设置Content-Type（让浏览器自动设置multipart/form-data）
    if (config.data instanceof FormData) {
      // 不要手动删除Content-Type，让浏览器自动设置正确的multipart boundary
      // delete config.headers['Content-Type']
    }
    
    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.parse(new Date()) / 1000
      }
    }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 加载实例
let loadingInstance = null

// response拦截器
service.interceptors.response.use(
  response => {
    // 关闭加载提示
    if (loadingInstance) {
      loadingInstance.close()
    }
    
    const res = response.data
    
    // 根据后端返回的数据格式进行判断
    if (res.code !== undefined) {
      // 统一状态码处理
      if (res.code !== 200 && res.code !== 0) {
        Message({
          message: res.message || '请求失败',
          type: 'error',
          duration: 3 * 1000
        })
        
        // 未授权或token过期
        if (res.code === 401) {
          // 清除token
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          // 跳转到登录页
          window.location.href = '/login'
        }
        
        return Promise.reject(new Error(res.message || '请求失败'))
      } else {
        return res
      }
    } else if (res.success !== undefined) {
      // 处理包含success字段的返回格式
      if (res.success) {
        return res;
      } else {
        Message({
          message: res.message || '请求失败',
          type: 'error',
          duration: 3 * 1000
        });
        return Promise.reject(new Error(res.message || '请求失败'));
      }
    } else {
      // 如果后端没有返回统一格式，返回response.data
      return response.data
    }
  },
  error => {
    // 关闭加载提示
    if (loadingInstance) {
      loadingInstance.close()
    }
    
    console.error('响应错误:', error)
    
    // 网络错误提示
    let errorMessage = '网络异常，请稍后重试'
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMessage = '请求参数错误'
          break
        case 401:
          errorMessage = '未授权，请重新登录'
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          setTimeout(() => {
            window.location.href = '/login'
          }, 1000)
          break
        case 403:
          errorMessage = '拒绝访问'
          break
        case 404:
          errorMessage = '请求的资源不存在'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        default:
          errorMessage = error.response.data?.message || '请求失败'
      }
    } else if (error.request) {
      errorMessage = '网络连接失败，请检查网络'
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 3 * 1000
    })
    
    return Promise.reject(error)
  }
)

// 带加载状态的请求方法
export const requestWithLoading = (config = {}) => {
  // 显示加载状态
  if (config.loading !== false) {
    loadingInstance = Loading.service({
      lock: true,
      text: config.loadingText || '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  
  return service(config)
}

// 默认导出service实例
export default service
